import './meter.css'

/**
 * How far along something is toward a stated end — a campaign against its
 * goal. A hairline track and an ink fill, with no number of its own: the
 * figure beside it says the amount, and a second spelling of it here would be
 * one more thing to keep in step.
 *
 * Past the end the fill stops at full; exceeding a goal is said in words,
 * where the label can say by how much.
 */
export function Meter({
  share,
  label,
}: {
  /** 0 to 1, or more where the end has been passed. */
  share: number
  /** What the meter measures, for a screen reader. */
  label: string
}) {
  const shown = Math.min(1, Math.max(0, share))
  return (
    <div
      className="meter"
      role="meter"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(shown * 100)}
    >
      <span
        className="meter__fill"
        /* The share is this meter's own fact; the look of it is the sheet's. */
        style={{ inlineSize: `${shown * 100}%` }}
      />
    </div>
  )
}
